export default "__VITE_ASSET__Dg$Z$auw__"